import axiosFlow from '@/services/axios/axiosFlow'

export default class AgendamentoMensagensService {
  static async get() {
    return axiosFlow.get('agendamentos').then(res => res.data.data)
  }

  static async getById(id) {
    return axiosFlow.get(`agendamentos/${id}`).then(res => res.data.data)
  }

  static async getContadores() {
    return axiosFlow.get('agendamentos/contadores').then(res => res.data.data)
  }

  static async getAgendamentoContadores(agendamentoId) {
    return axiosFlow.get(`agendamentos/${agendamentoId}/contadores`).then(res => res.data.data)
  }

  static async criarAgendamentoMensagem(body) {
    return axiosFlow.post('agendamentos', body).then(res => res.data.data)
  }

  static async atualizarAgendamentoMensagem(agendamentoMensagemId, body) {
    return axiosFlow.put(`agendamentos/${agendamentoMensagemId}`, body).then(res => res.data.data)
  }

  static async confirmarAgendamentoMensagem(body) {
    return axiosFlow.post('agendamentos/confirmar', body).then(res => res.data.data)
  }

  static async copiarAgendamentoMensagem(agendamentoMensagemId) {
    return axiosFlow.post(`agendamentos/${agendamentoMensagemId}/copiar`).then(res => res.data.data)
  }
}
